var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"card-content"},[_c('section',{staticStyle:{"background":"#FFFFFF"}},[_c(_vm.component,{tag:"component",on:{"next":_vm.next}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }